import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { rupee } from "../lib/api";
import { CheckCircle2, Package } from "lucide-react";
import { OrderTimeline } from "../components/OrderTimeline";
import { trackPurchase } from "../lib/analytics";

export default function OrderConfirmation() {
  const { orderNumber } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get(`/orders/track/${orderNumber}`).then((r) => {
      setOrder(r.data);
      // PRIMARY Google Ads conversion — fires once per order (de-duped, refresh-safe)
      trackPurchase({ transactionId: orderNumber, value: r.data.grand_total, currency: "INR" });
    }).catch(() => {
      // Still record the conversion even if the order fetch briefly fails
      trackPurchase({ transactionId: orderNumber, currency: "INR" });
    });
  }, [orderNumber]);

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-12" data-testid="order-confirmation-page">
      <div className="text-center mb-8">
        <CheckCircle2 className="mx-auto text-green-600 mb-3" size={50} />
        <h1 className="font-serif text-4xl text-navy">Order Confirmed!</h1>
        <p className="text-muted-foreground mt-2">Order <span className="font-semibold text-navy">{orderNumber}</span> has been placed.</p>
      </div>
      {order && (
        <div className="bg-white rounded-xl border border-black/5 p-6">
          <OrderTimeline status={order.status} />
          <div className="gold-rule my-5" />
          <div className="space-y-2">
            {order.items.map((it, i) => (
              <div key={i} className="flex justify-between text-sm"><span className="text-navy">{it.name} × {it.quantity}</span><span className="text-muted-foreground">{rupee(it.total)}</span></div>
            ))}
          </div>
          <div className="flex justify-between font-semibold text-lg text-navy mt-4 pt-4 border-t border-black/10"><span>Total</span><span>{rupee(order.grand_total)}</span></div>
          <div className="flex gap-3 mt-6">
            <Link to={`/track/${orderNumber}`} className="flex-1 text-center bg-navy text-cream font-semibold py-3 rounded-full hover:bg-navy-soft transition-colors" data-testid="track-order-btn">Track Order</Link>
            <Link to="/menu" className="flex-1 text-center border border-navy/25 text-navy font-semibold py-3 rounded-full hover:border-gold transition-colors">Order More</Link>
          </div>
        </div>
      )}
    </div>
  );
}
